import React from "react";

import {
  Stack,
  StackItem,
  ToggleGroup,
  ToggleGroupItem,
  Title
} from "@patternfly/react-core";

const AppearanceSection = ({
  title,
  items,
  selected,
  onSelect,
}) => (
  <Stack hasGutter>
    <StackItem>
        <Title
          headingLevel="h6"
          size="md"
        >
          {title}
        </Title>
    </StackItem>

    <StackItem>
      <ToggleGroup>
        {items.map((item) => (
          <ToggleGroupItem
            key={item.id}
            buttonId={item.id}
            text={item.label}
            isSelected={selected === item.id}
            onChange={() => onSelect(item.id)}
          />
        ))}
      </ToggleGroup>
    </StackItem>
  </Stack>
);

export default AppearanceSection;